import { render, staticRenderFns } from "./SummonerHall.vue?vue&type=template&id=36f17a2a&"
import script from "./SummonerHall.vue?vue&type=script&lang=js&"
export * from "./SummonerHall.vue?vue&type=script&lang=js&"
import style0 from "./SummonerHall.vue?vue&type=style&index=0&id=36f17a2a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports